import { AutocompleteMultiselection } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { MULTISELECTION_SEPARATOR } from 'utils/constants'

type SelectionMenuOptions = React.ComponentProps<
  typeof AutocompleteMultiselection
>['options']

export type UseMultiselectionOnSelectProps = {
  selectedOptions: SelectionMenuOptions
  onChange: (value: { id: string; des: string }) => void
}

type SelectionType = 'toggle' | 'set'

export default function useMultiselectionOnSelect({
  selectedOptions,
  onChange
}: UseMultiselectionOnSelectProps) {
  return useCallback(
    (
      targetSelection: SelectionMenuOptions | SelectionMenuOptions[0],
      type: SelectionType = 'toggle'
    ) => {
      const newSelections = Array.isArray(targetSelection)
        ? targetSelection
        : [targetSelection]

      const currentSelectionsIds = selectedOptions.map((option) => option.id)

      const newSelectionsIds = newSelections.map((selection) => selection.id)

      const optionsAfterDeselection = selectedOptions.filter(
        (option) => !newSelectionsIds.includes(option.id)
      )

      const optionsAfterToggle = [
        ...optionsAfterDeselection,
        ...newSelections.filter(
          (selection) => !currentSelectionsIds.includes(selection.id)
        )
      ]

      const newSelectedOptions =
        type === 'toggle' ? optionsAfterToggle : newSelections

      const uuids = newSelectedOptions.map((option) => option.id)
      const descriptions = newSelectedOptions.map((option) => option.value)

      onChange({
        id: uuids.join(MULTISELECTION_SEPARATOR),
        des: descriptions.join(MULTISELECTION_SEPARATOR)
      })
    },
    [onChange, selectedOptions]
  )
}
